import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { getAddress, Interface, ZeroAddress } from 'ethers';
import { ERC721__factory, Multicall__factory } from 'public/abi/evm/types';
import useProvider from '~/composables/useProvider';
import useEnvs from './useEnvs';

export default () => {
  const { address } = useWeb3ModalAccount();
  const { blockchain } = useEnvs();
  const { getProvider } = useProvider();

  // TODO: rename
  const getInterfaceDecoded = (tokenIds: string) => {
    return ERC721__factory.createInterface().decodeFunctionResult('getTokenIds', tokenIds);
  };

  const getMulticallResult = (
    iface: Interface,
    tokensAddresses: string[],
    encodeMethod: string,
    provideUserAddress: boolean = false
  ): Promise<any[]> => {
    const validUserAddress = getAddress(address.value ?? ZeroAddress);
    const multicallContract = Multicall__factory.connect(blockchain.multicallAddress, getProvider());

    const calldata = iface.encodeFunctionData(encodeMethod, provideUserAddress ? [validUserAddress] : []);
    const multicallData = tokensAddresses.map((token: string) => [token, calldata]);

    return multicallContract?.tryAggregate.staticCall(
      true,
      multicallData.map((item) => ({
        target: item[0],
        callData: item[1]
      }))
    );
  };

  return {
    getMulticallResult,
    getInterfaceDecoded
  };
};
